import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TreeviewItem } from '../../lib/ngx-treeview/models/treeview-item';

@Injectable({
  providedIn: 'root',
})
export class TerritoryTreeService {
  private territoryTreeSubject = new BehaviorSubject<TreeviewItem[]>([]);

  setTerritoryTree(tree: TreeviewItem[]): void {
    this.territoryTreeSubject.next(tree);
  }

  getTerritoryTree(): TreeviewItem[] {
    return this.territoryTreeSubject.value;
  }

}

